import React, {createContext, useContext} from 'react';
import {
    useConfirmationDialog,
    ConfirmationOption,
} from 'shared/components/ConfirmationDialog/ConfirmationDialog';

interface DialogContextType {
    show?: boolean;
    showDialog?: (options: ConfirmationOption) => void;
    hideDialog?: () => void;
    setTitle?: (title: string) => void;
    setMessage?: (message: string | JSX.Element) => void;
    updateOptions?: (options: Partial<ConfirmationOption>) => void;
}

export const DialogContext = createContext<DialogContextType>({});

export const useDialogContext = () => {
    const context = useContext(DialogContext);
    if (!context) {
        throw new Error(
            'useDialogContext must be used within a DialogProvider'
        );
    }
    return context;
};

export const DialogProvider = ({children}: {children: JSX.Element}) => {
    const {
        show,
        dialog,
        showDialog,
        hideDialog,
        setTitle,
        setMessage,
        updateOptions,
    } = useConfirmationDialog();

    return (
        <DialogContext.Provider
            value={{
                show,
                showDialog,
                hideDialog,
                setTitle,
                setMessage,
                updateOptions,
            }}>
            {children}
            {dialog}
        </DialogContext.Provider>
    );
};
